// extracted by mini-css-extract-plugin
export default {"container":"ConsoleLog_container__+gvJL","line":"ConsoleLog_line__mx93+","patientData":"ConsoleLog_patientData__8aPwj","toc":"ConsoleLog_toc__rIzry"};